import { createFileRoute, useRouter } from '@tanstack/react-router';
import KawaiiChatManager from '@components/chat/chat_manager';
import ErrorBoundary from '@components/error';
import { createProtectedLoader } from '@components/apollo';
import { useCallback } from 'react';

export const Route = createFileRoute('/')({
  loader: createProtectedLoader(),
  component: ChatRoute,
});

function ChatRoute() {
  const router = useRouter();

  const handleSetChatId = useCallback((id: number) => {
    if (!id) {
      router.navigate({ to: '/' });
    }
    router.navigate({ to: '/chat/$chatId', params: { chatId: id?.toString() || 'new' } });
  }, []);

  return (
    <ErrorBoundary>
      <KawaiiChatManager chatId={null!} handleSetChatId={handleSetChatId} />
    </ErrorBoundary>
  );
}
